import React from 'react';
import { CustomCircularProgress } from './style';

function Loading() {
  return <CustomCircularProgress size={50} />;
}

export default Loading;
